import Button from '@atlaskit/button/new';
import * as React from 'react';
export default {
  Button,
  React
};